'use strict';

(function () {

  angular
    .module('specsguardApp')
    .component('sgProjectBuildings', {
      bindings: {
        project: '<',
        updateProject: '&'
      },
      templateUrl: 'app-legacy/project/administration/project.buildings.html',
      controller: 'ProjectBuildingsCtrl'
    });

})();
